import React from 'react'
import ViewCpdAttendanceList from '../../features/viewCpdAttendance/ViewCpdAttendanceList'

const ViewCpdAttendance = () => {
  return (
    <ViewCpdAttendanceList/>
  )
}

export default ViewCpdAttendance